import classNames from "classnames";
import { Badge, PopOver } from "../../atoms";
import { appIcon } from "../../../assets/icons";
import { getFormattedDate } from "../../../helpers";
import truncate from "lodash/truncate";

const Card = ({
  name,
  badges = [],
  createdAt,
  popOverOptions,
  shouldShowIcon = true,
  onClick,
}) => {
  return (
    <div
      className="col-span-12 md:col-span-6 xl:col-span-4 p-6 bg-gray-800 rounded-lg cursor-pointer hover:shadow-lg hover:bg-gray-700/75 hover:scale-[1.02] hover:duration-100"
      onClick={onClick}
    >
      <div className="flex items-center mb-6">
        <div className="flex items-center">
          {shouldShowIcon && (
            <div className="icon w-9 h-9 rounded-full grid place-items-center bg-emerald-500">
              <img src={appIcon} alt="app-icon" />
            </div>
          )}
          <h5
            className={classNames("text-sm leading-5 font-bold text-white", {
              "ml-3": shouldShowIcon,
            })}
            title={name}
          >
             {truncate(name, { length: 20 })} 
          </h5>
        </div>
        {popOverOptions && <div onClick={(e) => e.stopPropagation()} className="ml-auto">
          <PopOver options={popOverOptions} />
        </div>}
      </div>
      <div className="flex items-center">
        {
          badges?.map(({ value, color }) => (
            <Badge
              key={value}
              color={color}
              value={value}
              size="xs"
              classes="mr-2"
            />
          ))}
        <span className="text-sm text-gray-200 ml-auto">
          {createdAt && getFormattedDate(createdAt)}
        </span>
      </div>
    </div>
  );
};

export default Card;
